<template>
  <div class="client-room">
    <div class="client-head">
      <h1>Рабочий стол</h1>
      <v-chip :color="session?.status === 'active' ? 'primary' : 'error'" variant="tonal">{{ session?.status || 'проверка' }}</v-chip>
    </div>
    <v-alert v-if="error" type="error" variant="tonal">{{ error }}</v-alert>
    <div v-else class="card-grid client">
      <ClientTableCard v-for="item in state.table" :key="item.id" :item="item" :selected="state.selected_ids.includes(item.id)" @toggle="toggleSelection" @preview="openPreview" />
    </div>

    <v-dialog v-model="previewVisible" max-width="980">
      <v-card v-if="previewItem" class="preview-card">
        <v-img :src="previewItem.image_url" :alt="previewItem.title" max-height="78vh" contain />
        <v-card-title>{{ previewItem.title }}</v-card-title>
        <v-card-text>
          <div class="tag-row">
            <v-chip v-for="tag in previewItem.tags || []" :key="tag" size="small" variant="tonal">{{ tag }}</v-chip>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="previewVisible = false">Закрыть</v-btn>
          <v-btn :color="state.selected_ids.includes(previewItem.id) ? 'secondary' : 'primary'" :prepend-icon="state.selected_ids.includes(previewItem.id) ? 'mdi-close-circle-outline' : 'mdi-check-circle-outline'" @click="toggleSelection(previewItem)">
            {{ state.selected_ids.includes(previewItem.id) ? 'Снять выбор' : 'Выбрать' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';
import { api, unwrap } from '../api/http';
import { openSessionSocket } from '../api/socket';
import ClientTableCard from '../components/ClientTableCard.vue';
const route = useRoute();
const session = ref(null);
const error = ref('');
const state = reactive({ table: [], selected_ids: [] });
const previewVisible = ref(false);
const previewItem = ref(null);
let socket;
function applyState(next) { state.table = next.table || []; state.selected_ids = next.selected_ids || []; }
function openPreview(item) { previewItem.value = item; previewVisible.value = true; }
async function toggleSelection(item) {
  const ids = state.selected_ids.includes(item.id) ? state.selected_ids.filter((id) => id !== item.id) : [...state.selected_ids, item.id];
  applyState(unwrap(await api.post(`/api/client-sessions/${route.params.token}/selection`, { item_ids: ids })));
}
onMounted(async () => {
  try {
    const data = unwrap(await api.get(`/api/client-sessions/${route.params.token}`));
    session.value = data.session;
    applyState(data.state);
    socket = openSessionSocket({ clientToken: route.params.token, onEvent(event, data) {
      if (['auth_ok', 'table_set', 'table_clear', 'selection_set'].includes(event)) applyState(data.state || data);
      if (event === 'session_closed') session.value.status = 'closed';
    } });
  } catch (e) {
    error.value = 'Ссылка неактивна или срок действия закончился.';
  }
});
onBeforeUnmount(() => socket?.close());
</script>
